<app-candidate-feedback *ngIf="batchDetails.stage === 'enrollment'"  [batchDetails]="batchDetails"></app-candidate-feedback>
<cpac-form *ngIf="batchDetails.stage === 'assessment'"  [batchDetails]="batchDetails"></cpac-form>
